
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
table{
  max-width:100%;
  overflow:auto;
  display:inline-block;

  --table-head-font-size:var(--fs-lg);
  --table-head-font-weight:var(--fw-bold);
  --table-body-font-size:var(--fs-base);
  --table-body-font-weight:var(--fw-normal);
}

  table tbody{
    width:100%;
  }

  table tbody ul,
    table tbody ol{
      padding:0;
      font-size:var(--table-body-font-size);
    }

  table thead tr th{
    background-color:var(--brand-primary-dark-blue);
    color:var(--brand-white);
    text-align:center;
  }

  table th,
  table td{
    padding:var(--spacing-4);
    line-height:var(--lh-base);
    min-width:20ch;
  }

  table tbody th,
    table tbody td{
      font-size:var(--table-body-font-size);
    }

  table tbody td{
      font-weight:var(--table-body-font-weight);
    }

  table tbody th,
    table tbody strong{
      font-weight:var(--table-head-font-weight);
      font-family:var(--ff-bold);
    }

  table tbody tr{
      background-color:var(--brand-gray-300);
      border-bottom:solid 3px var(--brand-gray-600);
    }

  table tbody tr th{
      text-align:center;
    }

  table thead th,
    table thead th *,
    table thead td,
    table thead td *{
      font-family:var(--ff-bold);
      font-size:var(--table-head-font-size);
      font-weight:var(--table-head-font-weight);
      background-color:var(--brand-primary-dark-blue);
      color:var(--brand-white);
    }
`;